// extracted by mini-css-extract-plugin
module.exports = {"callCenterContainer":"AdacCallCenterPage_callCenterContainer__dsPOX"};